export default function (caseNumber) {
  return {
    name: "Recruitment Report Extension Request",
    pageInfo: {
      text: "Please upload the Recruitment Report Extension Request below. Your response will be added to the case documents and directed to an analyst for review.",
      coloring: "grey",
    },
    sections: [
      {
        fields: [
          {
            machine_name: "fileType",
            value: "Extension Request - 9142C Recruitment Report",
            widget: "text",
            style: {
              display: "none",
            },
          },
          {
            machine_name: "Recruitment_Report_Extension_Case_Number",
            widget: "text",
            label: "Case Number *",
            maxLength: 100,
            disabled: true,
            value: caseNumber || "",
          },
          {
            machine_name: "files",
            widget: "file_upload",
            file_upload: { fileType: "Extension Request - 9142C Recruitment Report" },
            accept_multiple: false,
            required: true,
            validate: ["required", "file_required"],
            checkFilesAdded: true,
            documentAuth: "dh",
          },
          {
            machine_name: "document_description",
            widget: "text",
            label: "Document Description",
            validate: ["required"],
            maxLength: 100,
          },
        ],
      },
    ],
  };
}
